/**
 * Credential API Client
 * Registry Credential CRUD API
 */

import { apiClient } from '@shared/api/client';
import type { Credential, CredentialFormData, CredentialListParams } from '../types/credential';

export const credentialApi = {
    /**
     * Registry Credential 목록 조회
     */
    getCredentials: (params?: CredentialListParams) => {
        return apiClient.get<Credential[]>('/entity_my/credential', { params });
    },

    /**
     * Registry Credential 상세 조회
     */
    getCredentialById: (id: string) => {
        return apiClient.get<Credential>(`/entity_my/credential/${id}`);
    },

    /**
     * ⚠️ getCredentialDecrypt 제거됨 (보안상 이유)
     * 복호화는 백엔드 내부에서만 수행됩니다.
     * SSM 로그인은 /api/marketplace/v1/malaysia/login에서 credential_id를 전달하면
     * 백엔드가 자동으로 복호화하여 처리합니다.
     */

    /**
     * Registry Credential의 유효한 SSM 세션 조회
     */
    getCredentialSession: (id: string, loginType: 'mycoid2016' | 'idpro') => {
        return apiClient.get<{ session_id: string | null; has_valid_session: boolean }>(`/entity_my/credential/${id}/session`, { 
            params: { login_type: loginType } 
        });
    },

    /**
     * Registry Credential 생성
     */
    createCredential: (data: CredentialFormData) => {
        return apiClient.post<Credential>('/entity_my/credential', data);
    },

    /**
     * Registry Credential 수정
     */
    updateCredential: (id: string, data: Partial<CredentialFormData>) => {
        return apiClient.put(`/entity_my/credential/${id}`, data);
    },

    /**
     * Registry Credential 삭제 (비활성화)
     */
    deleteCredential: (id: string) => {
        return apiClient.delete(`/entity_my/credential/${id}`);
    },
};
